import {
  NotificationsNoneOutlinedIcon,
  AccountBoxOutlinedIcon,
  DashboardOutlinedIcon,
  LocationOnOutlinedIcon,
  PetsOutlinedIcon,
  GroupWorkOutlinedIcon,
  GroupIcon,
  ManageAccountsIcon,
} from "../../icons";

export const routes = [
  {
    icon: DashboardOutlinedIcon,
    title: "dashboard",
    link: "/",
    // role: [1, 2, 3],
    role: [1],
  },
  {
    icon: DashboardOutlinedIcon,
    title: "gateway",
    link: "/gateway",
    role: [1],
  },
  {
    icon: LocationOnOutlinedIcon,
    title: "Location", // geofence
    link: "/map",
    // role: [1, 2, 3],
    role: [1],
  },
  {
    icon: GroupWorkOutlinedIcon,
    title: "devices",
    link: "/devices",
    // role: [1, 2, 3],
    role: [1],
  },
  {
    icon: PetsOutlinedIcon,
    title: "livestock",
    link: "/livestocks",
    // role: [1, 2, 3],
    role: [1],
  },
  {
    icon: GroupIcon,
    title: "Users",
    link: "/users",
    // role: [1, 2],
    role: [1],
  },
  {
    icon: ManageAccountsIcon,
    title: "Sub Admins",
    link: "/subadmins",
    role: [1],
  },
  {
    icon: NotificationsNoneOutlinedIcon,
    title: "alerts",
    link: "/alerts",
    // role: [1, 2, 3],
    role: [1],
  },
  {
    icon: AccountBoxOutlinedIcon,
    title: "profile",
    link: "/profile",
    // role: [1, 2, 3],
    role: [1],
  },
];
